// Bay Area humanoid-robot companies with facilities (July 2026)
export const COMPANIES = [
  {
    name: 'Tesla (Optimus)',
    robot: 'Optimus Gen 3',
    hq: 'Austin, TX (eng. Palo Alto)',
    facility: 'Fremont Factory (ex-Model S/X line) + Palo Alto R&D',
    scale: 'Target 1M/yr; >1,000 Gen 3 on floor (Jan 2026)',
    sanMateo: false,
    note: 'Production ramping July/Aug 2026 in converted Fremont space. 1M sq ft Optimus line.',
    lat: 37.4900, lng: -121.9500,
  },
  {
    name: '1X Technologies',
    robot: 'NEO home humanoid',
    hq: 'Palo Alto (relocating to San Carlos)',
    facility: 'NEO Factory, Hayward (58k sq ft) + new San Carlos plant',
    scale: '58k sq ft; 10k units yr⁻¹; 100k by end 2027',
    sanMateo: true,
    note: 'OpenAI-backed. San Carlos plant in San Mateo County — CLOSEST to Peninsula. Vertically integrated.',
    lat: 37.5070, lng: -122.2600,
  },
  {
    name: 'Figure AI',
    robot: 'Figure 03',
    hq: 'San Jose',
    facility: 'BotQ factory, San Jose campus',
    scale: '12,000/yr initial; ~1 robot/hr; 100k in 4 yrs',
    sanMateo: false,
    note: '$39B valuation. In-house battery line. Robots building robots. Closing UPS deal.',
    lat: 37.3382, lng: -121.8863,
  },
  {
    name: 'Agility Robotics',
    robot: 'Digit bipedal',
    hq: 'Salem, OR',
    facility: 'NEW 60,000 sq ft training facility, Fremont',
    scale: '60k sq ft; Digit in Amazon/Spanx warehouses',
    sanMateo: false,
    note: 'Going public via reverse merger 2026. First pure-play humanoid IPO.',
    lat: 37.5485, lng: -121.9886,
  },
  {
    name: 'Physical Intelligence (π)',
    robot: 'π0.7 model (robot-agnostic brain)',
    hq: 'San Francisco (Mission District)',
    facility: 'Warehouse lab, SF Mission',
    scale: '$5.6B valuation; >$1B raised',
    sanMateo: false,
    note: 'OpenAI/Bezos-backed. Foundation model for any robot. Does not build hardware.',
    lat: 37.7600, lng: -122.4100,
  },
  {
    name: 'Sunday Robotics',
    robot: 'Memo home robot',
    hq: 'Stanford spinout, Bay Area',
    facility: 'Bay Area HQ; 500+ home data-collection network',
    scale: '$1.15B valuation; $165M Series B (Mar 2026)',
    sanMateo: true,
    note: 'ACT-1 model; 99% laundry-fold claim; beta in homes 2026.',
    lat: 37.4300, lng: -122.1700,
  },
  {
    name: 'Dexterity',
    robot: 'Warehouse robotics',
    hq: 'Redwood City',
    facility: 'Redwood City HQ',
    scale: 'Unicorn valuation; production warehouse robots',
    sanMateo: true,
    note: 'Warehouse/logistics focus; industrial-grade deployment.',
    lat: 37.4852, lng: -122.2364,
  },
  {
    name: 'Dyna Robotics',
    robot: 'Manipulation robotics',
    hq: 'Redwood City',
    facility: 'Redwood City HQ',
    scale: 'Early-stage; manipulation focus',
    sanMateo: true,
    note: 'RWC robotics cluster member.',
    lat: 37.4852, lng: -122.2364,
  },
];

// Facility indicators for the map
export const CLUSTER_CITIES = [
  { name: 'San Carlos', lat: 37.507, lng: -122.260, type: 'manufacturing', company: '1X Technologies' },
  { name: 'Fremont', lat: 37.548, lng: -121.989, type: 'manufacturing', company: 'Tesla Optimus' },
  { name: 'Fremont', lat: 37.549, lng: -121.988, type: 'training', company: 'Agility Robotics' },
  { name: 'San Jose', lat: 37.338, lng: -121.886, type: 'manufacturing', company: 'Figure AI BotQ' },
  { name: 'Palo Alto', lat: 37.441, lng: -122.143, type: 'engineering', company: 'Tesla Robotics R&D' },
  { name: 'Hayward', lat: 37.635, lng: -122.102, type: 'manufacturing', company: '1X NEO Factory' },
  { name: 'San Francisco', lat: 37.760, lng: -122.410, type: 'research', company: 'Physical Intelligence' },
  { name: 'Redwood City', lat: 37.485, lng: -122.236, type: 'engineering', company: 'Dexterity / Dyna' },
  { name: 'Menlo Park', lat: 37.453, lng: -122.182, type: 'research', company: 'Sunday Robotics' },
];
